var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23435 10.6811C6.52681 6.62039 4.83006 3.74465 3.91823 3.06077C7.95638 0.911431 15.6419 -2.23442 14.0788 2.37689C12.1248 8.14102 6.94687 14.3936 9.1939 17.3245L2.94125 23.1864C-2.139 18.4969 0.303464 14.2959 3.23435 10.6811Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2094 11.4947C16.5019 7.43399 14.8052 4.55825 13.8933 3.87437C17.9315 1.72503 25.617 -1.42082 24.0539 3.19049C22.0999 8.95462 16.922 15.2072 19.169 18.1381L12.9164 24C7.8361 19.3105 10.2786 15.1095 13.2094 11.4947Z",
    fill: "white",
    fillOpacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1845 10.6811C26.477 6.62039 24.7803 3.74465 23.8684 3.06077C27.9066 0.911431 35.5921 -2.23442 34.029 2.37689C32.075 8.14102 26.8971 14.3936 29.1441 17.3245L22.8914 23.1864C17.8112 18.4969 20.2537 14.2959 23.1845 10.6811Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.63faab66b6f707afc28115a96bfe56b6.svg";
export { ForwardRef as ReactComponent };